import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
  PropType,
} from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";

import { last as Rlast } from "ramda";

import {
  CWorkOrderTask,
  CWorkOrderTaskLineItem,
} from "@/store/modules/workOrderTasks";

import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "buildWorkOrderTaskEditForm",

  props: {
    formWorkOrderTask: {
      type: Object as PropType<CWorkOrderTask>,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const cancelEdit = (evt: any) => {
      evt.preventDefault();
      ctx.emit("editCanceled");
    };

    const firstInput = ref<any>(null);

    const workOrderTasks = computed(() => {
      return $store.getters.workOrderTasks as CWorkOrderTask[];
    });

    const onSubmit = (evt: any) => {
      evt.preventDefault();

      const jsConn = new JSConn();

      let storeDispatch;

      jsConn.formParams = {
        ...props.formWorkOrderTask,
      };

      if (props.formWorkOrderTask.id === "new") {
        jsConn.formParams.id = uuidv4();
        storeDispatch = "createWorkOrderTask";
      } else {
        storeDispatch = "updateWorkOrderTask";
      }

      $store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          ctx.emit("editSuccessful");
        })
        .catch(_jsConn => {
          // this.hasTaskErrors = true;
          // this.taskErrors = jsConn.error["response"]["data"];
        });
    };

    onMounted(() => {
      if (props.formWorkOrderTask.id === "new") {
        const STEP_SIZE = 200;
        let lastTask = Rlast(workOrderTasks.value);

        // for the situations when there isn't a last task
        if (!lastTask) {
          props.formWorkOrderTask.sort_order = STEP_SIZE;
        } else {
          props.formWorkOrderTask.sort_order = lastTask.sort_order + STEP_SIZE;
        }
      }
      ctx.root.$nextTick(() => {
        if (firstInput.value) {
          firstInput.value.focus();
        }
      });
    });

    return {
      cancelEdit,
      onSubmit,

      firstInput,
    };
  },
});
